import { CustomServerError } from './CustomServerError'

export class TaxOfficeAuthenticationError extends CustomServerError {}
